var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form_title"},[_c('span',{staticClass:"form_title_text"},[_vm._v(_vm._s(_vm.title)+":")]),(_vm.tooltip)?_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":_vm.tooltip,"placement":"top-start"}},[_c('i',{staticClass:"el-icon-question"})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }